import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Row, Col, Button} from 'reactstrap';
import SolicitacaoStore from "../stores/SolicitacaoStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import TimesheetsPendentesStore from "../stores/TimesheetsPendentesStore";

@inject("store")
@DataWrapper
@observer
export class TimesheetsPendentes extends Component {
    constructor(props) {
        super(props);
        this.controller = new TimesheetsPendentesStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Timesheets pendentes");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <div className="filter-container">
                            <Button color="primary" onClick={() => this.controller.onExportExcel()} >Exportar excel</Button>
                        </div>
                    </LoadingBlockFields>
                    {this.controller.erro &&
                        <MensagemErro>
                            {this.controller.erro}
                        </MensagemErro>
                    }
                </div>
            </div>
        )
    }
}
